import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { getAllCookies, TOKEN, USER_ID, getIsNpiAdmin, getIsAdmin } from 'Lib';
import {
    getIsAccessAdminTracker,
    getIsAccessMyCarReservation,
    getIsAccessMyTracker,
    getIsAccessMyTraining,
    getIsAdminCarReservation,
    getIsAdminTraining,
    getIsDriver,
    setUrlIncoming
} from '../../lib';
const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
};
const Auth = {
    isAuthenticated: () => {
        const cookies = getAllCookies();
        let isAuth = false;

        if (cookies && cookies[TOKEN] && cookies[USER_ID]) {
            const decodedJwt = parseJwt(cookies[TOKEN]);
            if (decodedJwt.exp  < Date.now()) {
                isAuth = true;
            } else {
                isAuth = false;
            }
        }
        return isAuth;
    },
    isNpiAdmin: () => {
        const isAdmin = getIsNpiAdmin();
        return isAdmin.toString() === 'true';
    },
    isDriver: () => {
        const isDriver = getIsDriver();
        console.log('isDriver', isDriver);
        return isDriver.toString() === 'true';
    },
    isAdmin: () => {
        const isAdmin = getIsAdmin();
        return isAdmin.toString() === 'true';
    },
    isAdminTraining: () => {
        const isAdminTraining = getIsAdminTraining();
        return isAdminTraining.toString() === 'true';
    },
    isAdminCarReservation: () => {
        const isAdminCarReservation = getIsAdminCarReservation();
        // console.log("isAdminCarReservation", isAdminCarReservation)
        return isAdminCarReservation.toString() === 'true';
        // return true
    },
    isAccessMyTracker: () => {
        const isAdminTraining = getIsAccessMyTracker();
        return isAdminTraining.toString() === 'true';
        // return true
    },
    isAccessMyTraining: () => {
        const isAccessMyTraining = getIsAccessMyTraining();
        return isAccessMyTraining.toString() === 'true';
        // return true
    },
    isAccessMyCarReservation: () => {
        const isAccessMyCarReservation = getIsAccessMyCarReservation();
        return isAccessMyCarReservation.toString() === 'true';
        // return true
    },
    isAccessAdminTracker: () => {
        const isAccessAdminTracker = getIsAccessAdminTracker();
        return isAccessAdminTracker.toString() === 'true';
    }
};

const MyTrackerPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAccessMyTracker === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const MyTrainingPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAccessMyTraining === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const MyCarReservationPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAccessMyCarReservation === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const AdminCarReservationPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAdminCarReservation() === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const AdminTrainingPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAdminTraining() === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const AdminTrackerPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAccessAdminTracker() === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const DriverPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isDriver() === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const AdminPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isAdmin() === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const NPIPrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Auth.isNpiAdmin() === false) {
                return <Redirect to="/unauthen" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const PrivateRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                let urlIncoming = props.match.url;
                setUrlIncome(urlIncoming);
                return <Redirect to="/login" />;
            }

            if (Layout) {
                return <Layout {...props} Component={Component} />;
            } else {
                if (Component !== undefined) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }
        }}
    />
);

const PublicRoute = ({ component: Component, layout: Layout, staticContext, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                if (Auth.isAuthenticated() === true && props.match.url === '/login') {
                    return <Redirect to="/" />;
                }

                if (Layout) {
                    return <Layout {...props} Component={Component} />;
                } else {
                    if (Component !== undefined) {
                        return <Component {...props} />;
                    } else {
                        return null;
                    }
                }
            }}
        />
    );
};

const setUrlIncome = (url) => {
    setUrlIncoming(url);
};

export {
    PrivateRoute,
    PublicRoute,
    NPIPrivateRoute,
    AdminPrivateRoute,
    AdminTrainingPrivateRoute,
    MyTrackerPrivateRoute,
    MyTrainingPrivateRoute,
    MyCarReservationPrivateRoute,
    AdminCarReservationPrivateRoute,
    Auth,
    DriverPrivateRoute,
    AdminTrackerPrivateRoute
};



// WEBPACK FOOTER //
// ./src/app/routes/routePermission.js